<template>
  <div :class="$style.antiIndulgedLogin">
    <AntiIndulged 
      branch="login" 
      :type="antiInduledType"
      @submit="submit"
      @quitGame="quitGame"
      @close="close"
      @changeData="changeData"
      @confirm="confirm"
      @visitorModeLogin="visitorModeLogin"
      ref="antiInduled" 
      v-if="antiInduledType" 
      :isClient="true"
    />
  </div>
</template>

<script>
import AntiIndulged from '@/components/antiIndulged/index';
import { mapState, mapActions, mapMutations } from 'vuex';
import { isAndroid } from '@/libs/utils';
import { 
  registReturnGameFunction, 
  registQuitGameFunction, 
  registFinishedBindIDCardFunction,
  registLoginVerifySuccessFunction,
} from '@/bridge/AppJsBridge';
import { antiIndulged, idBind } from '@/api/user';
import { inithandler } from "@/bridge/jsBridge";

export default {
  name: '',
  data() {
    return {
      antiInduledType: [0, 1],
      // antiInduledType: null,
      user_id: '',
      jh_app_id: '',
      jh_channel: '',
      extra_data: '',
      msg: '',
      tipOrNot: false,
      antiIndulgedInfo: null,
      quit_type: null, // 判断是否是客户端弹出
    };
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      device_info: state => state.user.device_info
    })
  },
  components: {
    AntiIndulged
  },
  async mounted() {
    // app数据初始化
    await this.dataInit();

    this.initState()
  },
  methods: {
    ...mapActions({
      realNameVerify: 'user/realNameVerify',
      getUserCache: 'user/getCacheState',
      checkAntiIndulged: 'user/checkAntiIndulged',
      cacheUserState: 'user/cacheState'
    }),
    ...mapMutations({
      changeGlobalState: 'global/CHANGE_STATE',
      changeUserState: 'user/CHANGE_STATE',
    }),
    close() {
      registReturnGameFunction(null);
    },
    async dataInit() {
      const cacheList = [
        'user_id',
        'appkey',
        'channel',
        'extra_data',
        'device_info',
        'access_token',
        'is_audit_packet',
        'antiInduled_customer'
      ];
      await this.getUserCache(cacheList);
    },
    quitGame() {
      registQuitGameFunction(null);
    },
    initState() {
      const { quit_type } = this.$route.query;
      const {
        antiIndulgedInfo,
        idBindCheckState,
        // is_guest,
        // is_audit_packet,
        antiInduled_customer
      } = this.$store.state.user;
      this.antiIndulgedInfo = antiIndulgedInfo;
      this.quit_type = quit_type;

      if (!quit_type && antiIndulgedInfo) {
        /**
         * 非客户端打开，并且vuex中存存在防沉迷数据情况
         * fatigue_state  0 防沉迷开关关闭 1 防沉迷开关打开
         * code 相关提示窗口code，根据产品蓝湖中的设计稿判断，防沉迷打开关闭以fatigue_state判断
         */
        const { fatigue_state, user_info } = antiIndulgedInfo;
        if (!idBindCheckState) {
          // 非验证真实实名认证需要重新实名认证的情况, 此时是因为防沉迷走到这里，一定存在user_info
          this.antiInduledType = [fatigue_state === 0 ? 1 : 0, Number(user_info.code)];
        } else {
          this.antiInduledType = [fatigue_state === 0 ? 1 : 0, 1];
        }
      } else if (quit_type) {
        this.checkAntiIndulged().then(r => {
          this.antiIndulgedInfo = r;
          const {
            fatigue_state,
            user_info: { code, night_status },
          } = r;
          this.antiInduledType = [fatigue_state === 0 ? 1 : 0, Number(code)];
          // 未成年夜间登录情况 code返回5 night_status为1
          if (code == 5 && night_status == 1) this.antiInduledType = [0, 6];
        })
      }
    },
    /**
     * 提交实名认证
     * @param {Object} form 身份证信息表单
     * @param {number} flag 未成年用户提交认证标识，认证成功后跳转未成年用户认证成功确认界面 详见产品文档
     */
    async submit(form, flag) {
      form = {
        ...form,
        uid: this.userState.user_id,
        jh_app_id: this.userState.appkey,
        access_token: this.userState.access_token
      };
      const { id_card_name, id_card_num } = form;
      const verifyResult = await this.realNameVerify({ id_card_name, id_card_num });
      if (verifyResult) {
        // 验证失败
        this.$toast(verifyResult);
        if (flag) this.$refs.antiInduled.rebind();
      } else {
        try {
          const r = await idBind(form); 
          this.$toast('认证成功'); 
          this.changeUserState({ id_card_status: true });
          this.cacheUserState(['id_card_status']);
          setTimeout(() => {
            if (r.content.id_status == 2) {
              this.antiInduledType = [0, 4];
            } else {
              if (this.quit_type) {
                // 游客模式用尽弹窗后实名认证完通知客户端
                this.notifyRealName(r.content.id_status, 1);
              } else {
                // 登录时实名认证通知客户端
                const { fatigue_state, open } = this.antiIndulgedInfo;
                console.log(fatigue_state, open, this.antiIndulgedInfo)
                this.notifyLogin({ fatigue_state, open, id_status: r.content.id_status });
              }
            }
          }, 1500);
        } catch (error) {
          if (flag) this.$refs.antiInduled.rebind();
        }
      }
    },
    changeData(key, value) {
      this[key] = value;
    },
    /**
     * @param { string } type 当前防沉迷窗口类型
     * 针对不同情况的处理：
     * 1,2 开启实名认证未开防沉迷;用户可正常进入游戏，但会弹窗
     * 0,4 开启实名认证开启防沉迷，未成年实名认证后弹窗
     */
    confirm(type) {
      if (['1,2', '0,4'].includes(type)) {
        if (this.quit_type) {
          // 游客模式用尽，实名认证未成年用户后通知客户端
          this.notifyRealName(2, 1);
        } else {
          // 登录是未成年用户绑定，通知客户端登录
          const {
            fatigue_state,
            open,
            user_info: { code, id_status }
          } = this.antiIndulgedInfo;
          this.notifyLogin({ fatigue_state, open, id_status: 2 });
        }
      } else {
        // 登录跳出防沉迷关闭防沉迷窗口相关处理
        registReturnGameFunction(null)
      }
    },
    /**
     * 通知客户端登陆成功进入游戏
     * @param { Object } anti_indulged_info 防沉迷相关字段
     *
     */
    notifyLogin(anti_indulged_info) {
      this.$emit('toLogin', {
        ...anti_indulged_info,
        url: `${window.location.origin}/sdk/client/antiIndulged`
      });
    },
    // 游客模式登录
    visitorModeLogin() {
      const { fatigue_state, open } = this.antiIndulgedInfo;
      // 通知游客模式登录
      this.notifyLogin({ fatigue_state, open, id_status: 1 });
    },
    notifyRealName(id_status, close) {
      registFinishedBindIDCardFunction({ id_status, close })
    }
  }
};
</script>

<style lang="scss" module>
.antiIndulgedLogin {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $antiIndulged;
}
</style>